import { Component, OnInit, ɵSWITCH_TEMPLATE_REF_FACTORY__POST_R3__ } from '@angular/core';
import { HomePageService } from 'src/app/homepage/homepage.service';
import {ChangeHomepageContentsService} from './change-homepage-contents.service';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-change-homepage-contents',
  templateUrl: './change-homepage-contents.component.html',
  styleUrls: ['./change-homepage-contents.component.css']
})
export class ChangeHomepageContentsComponent implements OnInit {
  contentTitle: string = '';
  contentPoint1: string = '';
  contentPoint2: string = '';
  contentPoint3: string = '';
  tagHeading: string = '';
  tagLine: string = '';
  updateId: string = '';

  constructor(
    private changeHomepageContentsService: ChangeHomepageContentsService,
    private homepageService: HomePageService
  ) { }

  ngOnInit(): void {
    this.listHomePageData();
  }

  onUpdate() {
    this.changeHomepageContentsService.homepageContentsEdit({
      Id: this.updateId,
      title1: this.contentTitle,
      point1: [
        this.contentPoint1,
        this.contentPoint2,
        this.contentPoint3
      ],
      title2: this.tagHeading,
      point2: this.tagLine
    }).subscribe(() => {
      Swal.fire('Homepage Content Updated!');
      this.listHomePageData();
    });
  }

  listHomePageData() {
    this.homepageService.homepageContent().subscribe((data:any) => {
      // console.log(data);
      this.updateId = data.homePageList[0]._id;
      this.contentTitle = data.homePageList[0].title1;
      this.contentPoint1 = data.homePageList[0].point1[0];
      this.contentPoint2 = data.homePageList[0].point1[1];
      this.contentPoint3 = data.homePageList[0].point1[2];
      this.tagHeading = data.homePageList[0].title2;
      this.tagLine = data.homePageList[0].point2;
    });
  }

}
